import { UserStore } from 'stores'

export const getLanguageVariables = (languages, territoryType) => {
  const userLanguages = UserStore.userLanguageOptions
    .filter(language => !language.disabled)
    .map(language => {
      return language.value
    })

  if (String(territoryType).includes('brandCategory')) {
    return null
  }

  if (String(territoryType).includes('music')) {
    return ['all']
  }

  const filterValue = (languages as Record<string, string>)?.value
  const selectedLanguage = filterValue ? languages : userLanguages
  if (!territoryType) {
    return Array.isArray(selectedLanguage)
      ? ['all', ...selectedLanguage]
      : [(selectedLanguage as Record<string, string>)?.value]
  }
  return Array.isArray(selectedLanguage) ? selectedLanguage : [(selectedLanguage as Record<string, string>)?.value]
}
